import type { Patient, Reference } from '@medplum/fhirtypes'
import type { Editor } from '@tiptap/react'
import { useObservationValueMap } from '#src/components/rich-text-editor/conditional-display/useObservationValueMap.ts'

// Mounted beside an editor with conditional display on, to feed its
// conditions the recorded values; renders nothing.
export function ConditionValueFeed({
  editor,
  participant,
}: {
  editor: Editor | null
  participant: Reference<Patient> | null | undefined
}): null {
  useObservationValueMap(editor, participant)
  return null
}
